module.exports = __webpack_public_path__ + "static/media/Default25x25.3084ef33.png";